import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide } from "@mui/material";
import { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function WarningConfirm({title, text, onClose, onSuccess, open=false, color="info", success_text="Ok" }) {
    return (
        <Dialog open={open} onClose={onClose} TransitionComponent={Transition}>
            <DialogTitle color={color}>{title}</DialogTitle>
            <DialogContent>
                {text}
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="contained" color={color} onClick={onSuccess} style={{ textTransform: "none" }} >{success_text}</Button>
                <Button variant="outlined" onClick={onClose} style={{ textTransform: "none" }} >Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}
export default WarningConfirm;